import { lazy } from 'react';

// Update paths to match your actual file structure
const BasicInfoSection = lazy(() => import('../sections/BasicInfoSection'));
const CareerGoalsSection = lazy(() => import('@/components/onboarding/sections/CareerGoalsSection'));
const SkillsSection = lazy(() => import('@/components/onboarding/sections/SkillsSection'));
const PreferencesSection = lazy(() => import('@/components/onboarding/sections/PreferencesSection'));
const PersonalitySection = lazy(() => import('@/components/onboarding/sections/PersonalitySection'));
const SummarySection = lazy(() => import('@/components/onboarding/sections/SummarySection'));

// Add debug logging for component loading
const withDebugLogging = (importFn: () => Promise<any>, name: string) => {
  return importFn().catch(err => {
    console.error(`Failed to load ${name}:`, err);
    throw err;
  });
};

export const ONBOARDING_STEPS = [
  {
    id: 'basic-info',
    component: lazy(() => withDebugLogging(
      () => import('../sections/BasicInfoSection'),
      'BasicInfoSection'
    )),
    title: 'Basic Information',
  },
  {
    id: 'career-goals',
    component: lazy(() => withDebugLogging(
      () => import('@/components/onboarding/sections/CareerGoalsSection'),
      'CareerGoalsSection'
    )),
    title: 'Career Goals',
  },
  {
    id: 'skills',
    component: lazy(() => withDebugLogging(
      () => import('@/components/onboarding/sections/SkillsSection'),
      'SkillsSection'
    )),
    title: 'Skills Assessment',
  },
  {
    id: 'preferences',
    component: lazy(() => withDebugLogging(
      () => import('@/components/onboarding/sections/PreferencesSection'),
      'PreferencesSection'
    )),
    title: 'Learning Preferences',
  },
  {
    id: 'personality',
    component: lazy(() => withDebugLogging(
      () => import('@/components/onboarding/sections/PersonalitySection'),
      'PersonalitySection'
    )),
    title: 'Personality Insights',
  },
  {
    id: 'summary',
    component: lazy(() => withDebugLogging(
      () => import('@/components/onboarding/sections/SummarySection'),
      'SummarySection'
    )),
    title: 'Review & Confirm',
  }
] as const;

export const mapDbDataToStep = (stepId: string, data: any) => {
  switch (stepId) {
    case 'basic-info':
      return {
        experienceLevel: data?.experienceLevel,
        learningGoals: data?.learningGoals,
        studyPreference: data?.studyPreference,
        pacePreference: data?.pacePreference
      };
    case 'career-goals':
      return data?.careerGoals;
    case 'skills':
      return data?.skills;
    case 'preferences':
      return data?.preferences;
    case 'personality':
      return data?.personality;
    case 'summary':
      return data?.summary;
    default:
      return undefined;
  }
};

export const mapStepDataToDb = (stepId: string, data: any) => {
  switch (stepId) {
    case 'basic-info':
      return {
        experienceLevel: data.experienceLevel,
        learningGoals: data.learningGoals,
        studyPreference: data.studyPreference,
        pacePreference: data.pacePreference
      };
    case 'career-goals':
      return {
        careerGoals: data
      };
    case 'skills':
      return {
        skills: data
      };
    case 'preferences':
      return {
        preferences: data
      };
    case 'personality':
      return {
        personality: data
      };
    case 'summary':
      return {
        summary: data
      };
    default:
      return {};
  }
};